import { render, staticRenderFns } from "./ServiceExtendTemplate.vue?vue&type=template&id=1400bd52"
import script from "./ServiceExtendTemplate.vue?vue&type=script&lang=js"
export * from "./ServiceExtendTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports